import { render, staticRenderFns } from "./blockExercise.vue?vue&type=template&id=b4dc3634"
import script from "./blockExercise.vue?vue&type=script&lang=js"
export * from "./blockExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports